import './ErrorMessage.scss';

import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import type { ApiErrorDetail } from 'common/models';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useId, useState } from 'react';

interface ErrorMessageProps {
  error: ApiErrorDetail;
}

const ErrorMessage = ({ error }: ErrorMessageProps) => {
  const { tError, tCommon } = useCustomTranslation();

  const [showMore, setShowMore] = useState(false);
  const detailsId = useId();

  return (
    <div className="ErrorMessage">
      <div className="ErrorMessage_title">{error.title}</div>
      {error.errorMessage ? (
        <div className="ErrorMessage_description">{error.errorMessage}</div>
      ) : (
        error.errorCode && <div className="ErrorMessage_description">{tError(error.errorCode)}</div>
      )}
      {error.traceId && (
        <div className="ErrorMessage_code">{tError('trace_id', { traceId: error.traceId })}</div>
      )}
      {error.detail && (
        <div>
          <button
            type="button"
            className="ErrorMessage_more"
            aria-expanded={showMore}
            aria-controls={detailsId}
            onClick={() => setShowMore((previous) => !previous)}
          >
            <span>{tCommon('more_info')}</span>
            <Icon path={showMore ? mdiChevronUp : mdiChevronDown} />
          </button>
          <div id={detailsId} hidden={!showMore}>
            {error.detail}
          </div>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage;
